var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/activityfeed/parts/getcpmclient',["require", "exports", "common/parts", "areas/activityfeed/models/dto"], function (require, exports, Parts, Dto) {
    "use strict";
    var GetCPMClient = (function (_super) {
        __extends(GetCPMClient, _super);
        function GetCPMClient(baseUrl) {
            _super.call(this);
            this._baseUrl = baseUrl;
        }
        GetCPMClient.prototype.process = function (symbol) {
            var _this = this;
            try {
                var url = this._baseUrl + "/sdn/rest/api/cpm/clientapicontract?organization=" + symbol.officeId + "&session=" + symbol.sessionId;
                Q(jQuery.ajax(url, {
                    type: "GET",
                    async: true,
                    beforeSend: function (xhr, settings) {
                        xhr.setRequestHeader("Authorization", "Bearer " + symbol.token.access_token);
                    },
                    contentType: "application/json"
                }))
                    .then(function (response) {
                    var client = Enumerable.From(response.data)
                        .FirstOrDefault(null, function (x) { return x.id === "1d6526c1-4b54-421d-a38f-5730639d2d92"; }); // TODO: ACHTUNG Hier muss der richtige rein!
                    var result = new Dto.ClientResponse();
                    result.token = symbol.token;
                    result.sessionId = symbol.sessionId;
                    result.organizationId = symbol.organizationId;
                    result.officeId = symbol.officeId;
                    result.clientId = client.id;
                    _this.output.call(result);
                });
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return GetCPMClient;
    }(Parts.Part));
    return GetCPMClient;
});

